import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js'
import Page from 'src/components/Page.js'
import {KeyboardBackspaceOutlined} from '@material-ui/icons'
// material
import { LoadingButton } from '@material-ui/lab'
import { Autocomplete, Checkbox } from '@material-ui/core'
import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  FormHelperText,
  Container,
  FormControlLabel,
} from '@material-ui/core'
import { Block } from 'src/pages/components-overview/Block.js'
// utils
// import { fData } from '../../../utils/formatNumber';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js'
import { Link as RouterLink } from 'react-router-dom'
//
import Label from 'src/components/Label.js'
import axios from 'axios'
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'

// ----------------------------------------------------------------------

// UserRoleEdit.propTypes = {
//   isEdit: PropTypes.bool,
//   currentUser: PropTypes.object
// };

export default function UserRoleViewData({viewId}) {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('user'))
  const userId = user.user_id
  const isClient = user.isClient
  const userType =isClient ? 3 : user.user_type
  let userRoleId = viewId
  const { enqueueSnackbar } = useSnackbar()
  const [permissionState, setPermissionState] = useState([])
  const [editUserData, setEditUserData] = useState([])
  const [checkedCheckboxIds, setCheckedCheckboxIds] = useState([])
  const [previousPermissions,setPreviousPermissions] = useState([]);
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  })

  const handleback = () => {
    window.history.back()
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editUserData.name ? editUserData.name : '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('values.name', values.name)
        console.log('checkedCheckboxIds---', checkedCheckboxIds)
        if(checkedCheckboxIds.length>0){
          const permission = checkedCheckboxIds.join(',');
          const response = await axios.post(`${REST_API_END_POINT}settings/edit-user-role`, 
          {name:values.name,userId:userId,userRoleId:userRoleId,permissions:permission});
          if(response.data.status === 1){
            enqueueSnackbar(response.data.message, { variant: 'success' })
            resetForm()
            navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: userRoleId } })
          }
          else if(response.data.status === 0){
            enqueueSnackbar(response.data.message, { variant: 'error' })
          }
          else {
            enqueueSnackbar("Server Error", { variant: 'error' })
          }
        }
        else{
          enqueueSnackbar("Please select atleast 1 user permission", { variant: 'error' })
        }
      } catch (error) {
        console.error("edit user role error : ",error)
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const { errors, values, touched, setFieldValue, getFieldProps } = formik

  const formatPermissions = (rawPermissions) => {
    const grouped = {}
    Object.keys(rawPermissions).forEach((module) => {
      const modulePerms = rawPermissions[module]
      const parentMap = modulePerms.reduce((acc, perm) => {
        if (!perm.parent_id) {
          acc[perm.id] = { ...perm, children: [] }
        }
        return acc
      }, {})
      modulePerms.forEach((perm) => {
        if (perm.parent_id && parentMap[perm.parent_id]) {
          parentMap[perm.parent_id].children.push({ ...perm })
        }
      })
      grouped[module] = Object.values(parentMap)
    })
    return grouped
  }

  const fetchData = async () => {
    try {
      axios.post(`${REST_API_END_POINT}settings/get-all-settings`, { userId, userType })
        .then((response) => {
          const data = response.data.results
          const relevantPermissions = (data?.permissions?.Request || []).filter((p) =>
            ['Create Request', 'Submit Proposal', 'Edit Request Proposal', 'Delete Request Proposal'].includes(p.name),
          )
          const clientPermissions = { 'Client Permissions': relevantPermissions.filter((p) => p.name === 'Create Request') }
          const vendorPermissions = {
            'Vendor Permissions': relevantPermissions.filter((p) =>
              ['Submit Proposal', 'Edit Request Proposal', 'Delete Request Proposal'].includes(p.name),
            ),
          }
          const allowedModules = ['Request', 'Projects', 'Estimate', 'Design Order', 'Production Control Board', 'Settings']
          const filteredPermissions = Object.keys(data.permissions || {})
            .filter((moduleName) => allowedModules.includes(moduleName) || moduleName === 'Sales Order' || moduleName === 'Request')
            .reduce((obj, key) => {
              if (key === 'Projects') {
                const viewPermission = (data.permissions[key] || []).filter((perm) => perm.name?.trim() === 'View Projects')
                if (viewPermission.length > 0) obj[key] = viewPermission
              } else if (key === 'Request') {
                const exclude = ['Manage Discount', 'Submit Proposal', 'Edit Request Proposal', 'Delete Request Proposal']
                const filtered = (data.permissions[key] || []).filter((perm) => !exclude.includes(perm.name?.trim()))
                if (filtered.length > 0) obj[key] = filtered
              } else if (key === 'Production Control Board') {
                const exclude = ['Clients', 'Upload Receipt', 'Financial Analysis', 'Utilization', 'Installs']
                const filtered = (data.permissions[key] || []).filter((perm) => !exclude.includes(perm.name?.trim()))
                if (filtered.length > 0) obj[key] = filtered
              } else if (key === 'Design Order') {
                const exclude = ['View Design Order Jobs', 'Hold Design Order Jobs', 'Manage Design Order Job Cost', 'Add Member to Design Order Job', 'Delete Member from Design Order Job', 'Add Design to Design Order Job', 'Delete Design from Design Order Job', 'View Design Order Calendar', 'Manage Design Order Calendar', 'View Estimate Calendar', 'Manage Estimate Calendar', 'Drag And Drop Estimate Calendar']
                const filtered = (data.permissions[key] || []).filter((perm) => !exclude.includes(perm.name?.trim()))
                if (filtered.length > 0) obj[key] = filtered
              } else if (key === 'Settings') {
                const exclude = ['Manage Clock-In-Out Time Settings', 'Production Control Board Settings', 'Client Ranking', 'Company Profile', 'Integrations', 'Contact Tags', 'Company Social Links']
                const filtered = (data.permissions[key] || []).filter((perm) => !exclude.includes(perm.name?.trim()))
                if (filtered.length > 0) obj[key] = filtered
              } else {
                obj[key] = data.permissions[key] || []
              }
              return obj
            }, {})
          let formatted
          if (userType === 3) {
            formatted = formatPermissions(filteredPermissions)
          } else if (userRoleId == 3) {
            formatted = formatPermissions({ ...clientPermissions, ...vendorPermissions })
          } else {
            formatted = formatPermissions(data.permissions || {})
          }
          setPreviousPermissions(formatted)
        })
        .catch((error) => console.error('userrole fetchData Error:', error))
    } catch (error) {
      console.error('userrole fetchData Error:', error)
    }
  }

  const fetchEditData = async () => {
    try {
      axios.post(`${REST_API_END_POINT}settings/get-user-role`, { userRoleId })
        .then((response) => {
          setEditUserData(response.data?.result || {})
          const editUserPermissions = response.data?.result?.user_permissions
          const dataArray = editUserPermissions ? editUserPermissions.split(',').map(Number) : []
          setCheckedCheckboxIds(dataArray)
        })
        .catch((error) => {
          console.error('userrole fetchEditData Error:', error)
          setCheckedCheckboxIds([])
        })
    } catch (error) {
      console.error('userrole fetchEditData Error:', error)
      setCheckedCheckboxIds([])
    }
  }

  useEffect(() => {
    fetchData()
    fetchEditData()
  }, [])

  useEffect(() => {
    const updatedPermissions = { ...previousPermissions }
    for (const moduleName in updatedPermissions) {
      if (!Object.prototype.hasOwnProperty.call(updatedPermissions, moduleName)) continue
      updatedPermissions[moduleName] = (updatedPermissions[moduleName] || []).map((perm) => {
        let updatedPerm = { ...perm }
        if (perm.children && perm.children.length > 0) {
          updatedPerm.children = perm.children.map((child) => ({
            ...child,
            checked: checkedCheckboxIds.includes(child.id),
          }))
          const allChildrenChecked = updatedPerm.children.every((c) => c.checked)
          const someChildrenChecked = updatedPerm.children.some((c) => c.checked)
          updatedPerm.checked = allChildrenChecked
          updatedPerm.indeterminate = !allChildrenChecked && someChildrenChecked
        } else {
          updatedPerm.checked = checkedCheckboxIds.includes(perm.id)
          updatedPerm.indeterminate = false
        }
        return updatedPerm
      })
    }
    setPermissionState(updatedPermissions)
  }, [previousPermissions, checkedCheckboxIds])

  return (
    <Page title={`User Role View | ${COMPANY_NAME}`}>
      <Container>
        {/* <HeaderBreadcrumbs heading="User Role View" /> */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={10}>
                <Stack spacing={3}>
                  <Stack
                    justifyContent="space-between"
                    direction={{ xs: 'column', sm: 'column' }}
                  >
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      sx={{ mb: 4 }}
                    >
                      <TextField
                        fullWidth
                        label="Name"
                        type="text"
                        sx={{cursor:'auto'}}
                        InputProps={{ readOnly:true }}
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Stack>
                    {permissionState &&
                      Object.keys(permissionState).length > 0 &&
                      (() => {
                        const nullModuleData = permissionState[null] ?? permissionState['null'] ?? []
                        const isFullAdminChecked = nullModuleData.some((item) =>
                          checkedCheckboxIds.includes(item.id),
                        )
                        const getModuleDisplayName = (name) => {
                          if (name === 'Request') return 'Sales Order'
                          if (name === 'Jobs') return 'Production'
                          if (name === 'Receive Inventory') return 'Purchase Order'
                          return name
                        }
                        const getParentCheckboxState = (item) => {
                          if (!item.children || item.children.length === 0) {
                            return { checked: item.checked || false, indeterminate: false }
                          }
                          const checkedStates = item.children.map((c) => c.checked)
                          const allChecked = checkedStates.every(Boolean)
                          const someChecked = checkedStates.some(Boolean) && !allChecked
                          return { checked: allChecked, indeterminate: someChecked }
                        }
                        return Object.entries(permissionState).map(([moduleName, moduleData], index) => {
                          const allChecked = moduleData.every((item) => item.checked)
                          const someChecked = moduleData.some((item) => item.checked)
                          const isNullModule = moduleName == null || moduleName === 'null'
                          const displayName = getModuleDisplayName(moduleName)
                          const showFullModule = isFullAdminChecked && !isNullModule
                          const dataToShow = showFullModule
                            ? moduleData
                            : moduleData.filter((item) => {
                                const { checked: pChecked, indeterminate: pIndeterminate } = getParentCheckboxState(item)
                                return pChecked || pIndeterminate
                              })
                          if (!showFullModule && dataToShow.length === 0) return null

                          return (
                            <Stack key={index} spacing={{ xs: 2, sm: 1 }}>
                              <Stack>
                                {!isNullModule && (
                                  showFullModule ? (
                                    <FormControlLabel
                                      sx={{ cursor: 'default' }}
                                      label={displayName}
                                      control={
                                        <Checkbox
                                          checked
                                          indeterminate={false}
                                          sx={{ cursor: 'auto' }}
                                        />
                                      }
                                    />
                                  ) : (
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                      {displayName}
                                    </Typography>
                                  )
                                )}
                                {dataToShow.map((item, optionIndex) => {
                                  const { checked: parentChecked, indeterminate: parentIndeterminate } = getParentCheckboxState(item)
                                  const childrenToShow = showFullModule
                                    ? (item.children || [])
                                    : (item.children || []).filter((c) => c.checked)
                                  return (
                                    <React.Fragment key={optionIndex}>
                                      <FormControlLabel
                                        sx={{ marginLeft: isNullModule ? '-10px' : '40px', cursor: 'default' }}
                                        label={item.name
                                          .replace(/request/gi, 'Sales Order')
                                          .replace(/Design Order Jobs?/gi, 'Design Jobs')}
                                        control={
                                          <Checkbox
                                            checked={showFullModule ? true : parentChecked}
                                            indeterminate={showFullModule ? false : parentIndeterminate}
                                            sx={{ cursor: 'auto' }}
                                          />
                                        }
                                      />
                                      {childrenToShow.map((child, childIndex) => (
                                        <FormControlLabel
                                          key={`child-${childIndex}`}
                                          sx={{ marginLeft: '80px', cursor: 'default' }}
                                          label={child.name}
                                          control={
                                            <Checkbox
                                              checked
                                              sx={{ cursor: 'auto' }}
                                            />
                                          }
                                        />
                                      ))}
                                    </React.Fragment>
                                  )
                                })}
                              </Stack>
                            </Stack>
                          )
                        })
                      })()}
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
      </Container>
    </Page>
  )
}
